import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import { LiturgicalProvider } from "@/context/LiturgicalContext";
import Home from "@/pages/Home";
import CalendarPage from "@/pages/Calendar";
import DayPage from "@/pages/DayPage";
import Prayers from "@/pages/Prayers";
import PrayerDetail from "@/pages/PrayerDetail";
import Rosary from "@/pages/Rosary";
import Stations from "@/pages/Stations";
import WhyPray from "@/pages/WhyPray";
import HowToPray from "@/pages/HowToPray";
import WhatToPray from "@/pages/WhatToPray";
import TopicPage from "@/pages/TopicPage";
import Companion from "@/pages/Companion";
import Wall from "@/pages/Wall";
import Shop from "@/pages/Shop";
import Support from "@/pages/Support";
import LeadMagnets from "@/pages/LeadMagnets";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";

function App() {
    return (
        <LiturgicalProvider>
            <BrowserRouter>
                <Layout>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/calendar" element={<CalendarPage />} />
                        <Route path="/day/:date" element={<DayPage />} />
                        <Route path="/prayers" element={<Prayers />} />
                        <Route path="/rosary" element={<Rosary />} />
                        <Route path="/stations" element={<Stations />} />
                        <Route path="/why-we-pray" element={<WhyPray />} />
                        <Route path="/how-to-pray" element={<HowToPray />} />
                        <Route path="/what-to-pray" element={<WhatToPray />} />
                        <Route path="/topics/:slug" element={<TopicPage />} />
                        <Route path="/prayers/:slug" element={<PrayerDetail />} />
                        <Route path="/companion" element={<Companion />} />
                        <Route path="/wall" element={<Wall />} />
                        <Route path="/shop" element={<Shop />} />
                        <Route path="/support" element={<Support />} />
                        <Route path="/lead-magnets" element={<LeadMagnets />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/payment/success" element={<PaymentSuccess />} />
                        <Route path="/payment/cancel" element={<PaymentCancel />} />
                    </Routes>
                </Layout>
                <Toaster position="top-center" richColors />
            </BrowserRouter>
        </LiturgicalProvider>
    );
}

export default App;
